'use client';

import { useEffect, useRef } from 'react';

import AppImage from '@/components/ui/AppImage';

const services = [
{
  icon: 'BeakerIcon',
  title: 'Ontstopping van leidingen',
  description: 'WC verstopt, gootsteen geblokkeerd of afvoer dicht? Wij ontstoppen snel en efficiënt met hogedrukspuiting en elektrische veer. Resultaat gegarandeerd.',
  price: 'Vanaf 89€',
  tags: ['WC', 'Gootsteen', 'Hogedruk', 'Elektrische veer'],
  image: "/assets/images/25beecf7-64ca-49e2-a11c-b70d09310d5f-1772972582036.JPG",
  imageAlt: 'Machine voor het ontstoppen van leidingen in een badkamer',
  span: 'col-span-1 md:col-span-2 lg:col-span-2',
  imgHeight: 'h-48 lg:h-72'
},
{
  icon: 'WrenchIcon',
  title: 'Lekdetectie & Lekreparatie',
  description: 'Waterlek in muur, vloer of leiding? Wij lokaliseren het lek nauwkeurig en herstellen het snel — zonder onnodige afbraak. Schade beperkt, factuur transparant.',
  price: 'Prijs vooraf aangekondigd',
  tags: ['Verborgen lekken', 'Waterschade', 'Snel', 'Gegarandeerd'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19ebded72-1772293137969.png",
  imageAlt: 'Loodgieter die een lek repareert in een woonleiding',
  span: 'col-span-1 lg:col-span-1',
  imgHeight: 'h-48 lg:h-72'
},
{
  icon: 'WrenchScrewdriverIcon',
  title: 'Reparaties',
  description: 'Defecte kraan, gebarsten leiding, kapotte spoelbak of ander loodgietersprobleem? Wij herstellen snel en vakkundig, met garantie op het uitgevoerde werk.',
  price: 'Gratis offerte',
  tags: ['Kranen', 'Leidingen', 'Sanitair', 'Garantie'],
  image: "/assets/images/PHOTO-2026-03-08-13-27-00-1773002056138.jpg",
  imageAlt: 'Loodgieter die werkt aan koperen leidingen in een kelder',
  span: 'col-span-1 lg:col-span-1',
  imgHeight: 'h-48 lg:h-72'
},
{
  icon: 'BoltIcon',
  title: 'Spoedinterventies 24/7',
  description: 'Noodgeval dag of nacht? Wij zijn 24u/24, 7d/7 bereikbaar en staan binnen 2 uur bij u. Geen wachttijd, geen excuses — alleen snelle hulp wanneer u het nodig heeft.',
  price: 'Snelle interventie',
  tags: ['24/7', 'Spoed', 'Binnen 2u', 'Weekends'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b017d58-1772293140878.png",
  imageAlt: 'Loodgieter bij spoedinterventie met professioneel materiaal',
  span: 'col-span-1 md:col-span-2 lg:col-span-2',
  imgHeight: 'h-40 lg:h-64'
},
{
  icon: 'FireIcon',
  title: 'Installatie & onderhoud van boilers',
  description: 'Installatie, vervanging en jaarlijks onderhoud van elektrische, gas- en zonneboilers. Alle merken, gecertificeerde technici.',
  price: 'Prijs vooraf aangekondigd',
  tags: ['Elektrische boiler', 'Gasboiler', 'Jaarlijks onderhoud', 'Alle merken'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fad4fe52-1772203120790.png",
  imageAlt: 'Technicus die een moderne boiler installeert in een woning',
  span: 'col-span-1 lg:col-span-1',
  imgHeight: 'h-40 lg:h-64'
},
{
  icon: 'ArrowPathIcon',
  title: 'Installatie & reparatie van ketels',
  description: 'Ketel in panne of aan vervanging toe? Wij installeren en herstellen ketels van alle merken. Gecertificeerd voor gas, snelle interventie.',
  price: 'Gratis offerte',
  tags: ['Viessman', 'Bulex', 'Daikin', 'Gascertificaat'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c16447a8-1772889512910.png",
  imageAlt: 'Loodgieter die een wandketel installeert in een woning',
  span: 'col-span-1 lg:col-span-1',
  imgHeight: 'h-40 lg:h-64'
},
{
  icon: 'MagnifyingGlassIcon',
  title: 'Camera-inspectie',
  description: 'Endoscopische camera en thermografie voor nauwkeurige diagnose van leidingen en installaties. Snel, niet-invasief en betrouwbaar.',
  price: 'Offerte ter plaatse',
  tags: ['Camera', 'Thermografie', 'Niet-invasief', 'Nauwkeurig'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c31404bf-1772293136764.png",
  imageAlt: 'Technicus die een endoscopische camera gebruikt om een leiding te inspecteren',
  span: 'col-span-1 lg:col-span-1',
  imgHeight: 'h-40 lg:h-64'
},
{
  icon: 'ClipboardDocumentCheckIcon',
  title: 'Preventief onderhoud',
  description: 'Jaarlijkse onderhoudscontracten voor ketels, boilers en loodgieterijinstallaties. Vermijd dure pannes en verleng de levensduur van uw installatie.',
  price: 'Jaarcontract',
  tags: ['Contract', 'Jaarlijks', 'Preventief', 'Besparing'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10313fe0f-1772293137877.png",
  imageAlt: 'Technicus die preventief onderhoud uitvoert op een loodgieterijinstallatie',
  span: 'col-span-1 lg:col-span-1',
  imgHeight: 'h-40 lg:h-64'
},
{
  icon: 'ArrowsRightLeftIcon',
  title: 'Installatie & vervanging',
  description: 'Vervanging en installatie van kranen, mengkranen, sanitair en loodgieterijuitrusting. Verzorgd werk, snelle uitvoering, nette afwerking.',
  price: 'Vanaf 65€',
  tags: ['Kranen', 'Mengkranen', 'Sanitair', 'Snel'],
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a43204cd-1772293138965.png",
  imageAlt: 'Loodgieter die een nieuwe chromen kraan installeert in een moderne badkamer',
  span: 'col-span-1 lg:col-span-1',
  imgHeight: 'h-40 lg:h-64'
}];



export default function ServicesSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.15 }
    );

    const elements = sectionRef?.current?.querySelectorAll('.reveal-up, .section-line, .img-reveal');
    elements?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="services"
      className="px-5 py-5"
      style={{ background: 'rgba(255,255,255,0.5)' }}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-14">
          <div className="section-line mb-8" />
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.4em] mb-4 block reveal-up" style={{ color: '#16A34A' }}>
                Onze diensten
              </span>
              <h2
                className="font-display leading-tight reveal-up"
                style={{ fontSize: 'clamp(2rem,5vw,3.5rem)', fontWeight: 700, color: '#1A2B3C' }}>
                
                Al uw loodgieterij
                <br />
                <span className="font-display italic" style={{ color: '#16A34A', fontWeight: 400 }}>
                  problemen opgelost.
                </span>
              </h2>
            </div>
            <p
              className="max-w-xs text-sm font-medium leading-relaxed reveal-up"
              style={{ color: '#7A95AD' }}>
              
              Prijs schriftelijk bevestigd vóór aanvang. Geen onaangename verrassing op de factuur.
            </p>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 stagger-children">
          {services?.map((service, i) =>
          <div
            key={service?.title}
            className={`service-card glass-card rounded-2xl overflow-hidden reveal-up ${service?.span}`}
            style={{ border: '1px solid rgba(0,0,0,0.07)' }}>
            
              {/* Image */}
              <div className={`${service?.imgHeight} overflow-hidden relative img-reveal`}>
                <AppImage
                src={service?.image}
                alt={service?.imageAlt}
                fill
                className="object-cover opacity-100 group-hover:opacity-100 transition-opacity duration-700" />
              
                <div
                className="absolute inset-0" />
              
              
              </div>

              {/* Content */}
              <div className="p-5">
                <h3 className="text-base font-bold mb-2" style={{ color: '#1A2B3C' }}>
                  {service?.title}
                </h3>
                <p className="text-sm leading-relaxed mb-4" style={{ color: '#4A6580' }}>
                  {service?.description}
                </p>
                {/* Tags */}
                <div className="flex flex-wrap gap-2">
                  {service?.tags?.map((tag) =>
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full text-xs font-medium"
                  style={{
                    background: 'rgba(22,163,74,0.08)',
                    border: '1px solid rgba(22,163,74,0.15)',
                    color: '#16A34A'
                  }}>
                  
                      {tag}
                    </span>
                )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );

}